<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="c13"><a id="page14"></a>Captive Audience</h1>
<p class="nonindent">A Zambian court presided over by Judge Alfred Shilibwa granted a man a divorce on the grounds that his wife’s suspicions and lack of commitment had permanently undermined their relationship. The judge was referring to the woman’s habit of locking her husband in his bedroom every night so he wouldn’t sneak out and have an affair. I can just imagine the man’s cries for help: “Honey, I don’t want to have an affair, I just want to go to the bathroom.”<img alt="" src="OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"/></p>
<div class="textbox">
<p class="center"><img alt="" src="OEBPS/images/Greg_9780740792069_epub_L07_r1.jpg"/></p>
<p class="center02">A study of the effects of the abstinence-only <span class="big1">sex education</span> programs in Texas schools (spearheaded by then-governor George Bush) got a bad report. The study showed that 23 percent of ninth-grade girls have already had sex by the time they receive the abstinence lessons, and after they attended, the percentage <span class="big1">increased.</span></p>
<p class="center"><img alt="" src="OEBPS/images/Greg_9780740792069_epub_L07_r1.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740792069_epub_c13_r1.vue?e545e36c